// extracted by mini-css-extract-plugin
export var container = "AboutUs-module--container--OpXDf";
export var image = "AboutUs-module--image--rWOFI";
export var lineLink = "AboutUs-module--line-link--AHicP";
export var lineLink_black = "AboutUs-module--line-link_black--lRHwk";
export var lineLink_grey = "AboutUs-module--line-link_grey--1hfWJ";
export var lineLink_primary = "AboutUs-module--line-link_primary--YSElx";
export var lineLink_secondary = "AboutUs-module--line-link_secondary--YB8wb";
export var lineLink_white = "AboutUs-module--line-link_white--9oSbo";
export var section = "AboutUs-module--section--simch";